export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL?.trim() || 'info@zoma-app.com';
